import { PersonalDetailsWithFullName } from './model/personal-details-with-full-name';
import { PersonalizationPerson } from './model/personalization-person';

export class SetFirstPerson {
  static readonly type = '[ShoppingCartPersonalization] Set first person';
  constructor(public firstPerson: PersonalizationPerson<string | null>) {}
}

export class SetAdditionalPersons {
  static readonly type = '[ShoppingCartPersonalization] Set additional persons';
  constructor(public additionalPersons: PersonalDetailsWithFullName[]) {}
}
